import {
  ContentRow,
  Box,
  Button,
  LocalizedString,
  useIsMobileLayout,
} from "@dbn/omnichannel-design-system-g4p";
import { IO } from "fp-ts/IO";
import { useSBDeepLink } from "../useSBDeepLink";
import { SBAuthorizationResultWaiting } from "./SBAuthorizationResultWaiting";
import { useState } from "react";
import { Path } from "../../APICall";
import { option, taskEither } from "fp-ts";
import { constVoid, pipe } from "fp-ts/function";
import { TaskEither } from "fp-ts/TaskEither";
import { Option } from "fp-ts/Option";
import { usePortalStatusContext } from "../../PortalStatusContext";

type Props = {
  label: LocalizedString;
  onProcessStart: () => unknown;
  processStarted: boolean;
  beforeAuthorizationAction: IO<unknown>;
  onCancelSignature: () => unknown;
  checkAuthorizationPushPath: Path;
  canStartProcess: Option<TaskEither<unknown, boolean>>;
  setAttemptedToSign?: (value: boolean) => void;
} & {
  onSuccess: () => unknown;
  biometric: boolean;
};

export function SBAuthorizationButton(props: Props) {
  const sbAuthorize = useSBDeepLink("Authorize", props.biometric);
  const [sbAuthorizeCalled, setSbAuthorizeCalled] = useState(false);
  const { portalBlocked } = usePortalStatusContext();
  const isMobileLayout = useIsMobileLayout();

  if (props.processStarted && !sbAuthorizeCalled) {
    setSbAuthorizeCalled(true);
    props.beforeAuthorizationAction();
    sbAuthorize();
  }

  const cancelSignatureRequest = () => {
    props.onCancelSignature();
    setSbAuthorizeCalled(false);
  };

  const onSignButtonClicked = () => {
    props.setAttemptedToSign?.(true);

    pipe(
      props.canStartProcess,
      option.fold(props.onProcessStart, canStartProcess =>
        pipe(
          canStartProcess,
          taskEither.map(canStartProcess =>
            canStartProcess ? props.onProcessStart() : constVoid
          )
        )()
      )
    );
  };

  return (
    <ContentRow type={isMobileLayout ? "full" : "lateral-margins"}>
      <Box column grow style={isMobileLayout ? { width: "100%" } : undefined}>
        {props.processStarted ? (
          <SBAuthorizationResultWaiting
            onSuccess={props.onSuccess}
            onCancel={cancelSignatureRequest}
            onFailure={cancelSignatureRequest}
            checkAuthorizationPushPath={props.checkAuthorizationPushPath}
          />
        ) : (
          <Button
            variant="primary"
            label={props.label}
            action={onSignButtonClicked}
            size="default"
            disabled={portalBlocked}
          />
        )}
      </Box>
    </ContentRow>
  );
}
